import styled from "styled-components/macro";
import { TableRow } from "@material-ui/core";

const ClickableTableRow = styled(TableRow)`
  cursor: pointer;
`;

export default ClickableTableRow;
